import React from 'react';
import _ from 'lodash';

import {
  BaseWidget,
  currencyUtil
} from 'modules';

import { Table } from 'iron-forge-react-modules';
import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export interface IProps {
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.orderId);



  const rows = React.useMemo(
    () => _.map(tuple.data.lineItems, (lineItem): types.IRow => ({
      id: lineItem.id,
      columnId2Value: {
        productName: {
          type: 'string',
          label: lineItem.productName
        },
        price: {
          type: 'string',
          label: currencyUtil.convertBigCentsToDollars(lineItem.lineTotalCents)
        },
        quantity: {
          type: 'string',
          label: lineItem.quantity.toString()
        },
        sku: {
          type: 'string',
          label: lineItem.sku
        }
      }
    })),
    [tuple]
  );

  return (
    <BaseWidget.FC title="Product Information">
      <TableComponent
        rows={rows}
        columns={[
          {
            id: 'sku',
            label: "Product"
          },
          {
            id: 'productName',
            label: "Product Detail"
          },
          {
            id: 'quantity',
            label: "Quantity"
          },
          {
            id: 'price',
            label: "Line Total"
          }
        ]} />
    </BaseWidget.FC>
  );
};
